import {ViewTypeEnum} from "../../../app/controls/General/ControlPanelControl/Definitions/ViewTypeEnum";

export namespace LinkBuilder {

    export interface IComposeLinkParamsParameter {
        name: string;
        value: any
    }

    export interface IComposeLinkParams {

        modulePresenter?: { module: string, presenter: string } | null;
        component: string | null;
        method: string | null;
        parameters: IComposeLinkParamsParameter[];
    }

    export class LinkBuilderController {

        /**
         * Wrapper for getQueryParamFromString using current URL
         * @param name - parameter name
         * @return string|null - parameter value or null if not present
         */
        public static getQueryParam(name: string) : string|null {
            return this.getQueryParamFromString(name, window.location.search);
        }

        /**
         * Wrapper for getQueryParamFromString using viewType param name
         * @param uriString - url string
         * @return string|null - parameter value or null if not present
         */
        public static getViewTypeFromString(uriString: string) : ViewTypeEnum|null {

            const viewTypeRaw = this.getQueryParamFromString('viewType', uriString);
            return viewTypeRaw ? parseInt(viewTypeRaw) : null;
        }

        /**
         * Get query parameter from URI using its name
         * @param name - parameter name
         * @param uriString - url string
         * @return string|null - parameter value or null if not present
         */
        public static getQueryParamFromString(name: string, uriString: string) : string|null {

            const urlParams = new URLSearchParams(uriString);
            const param = urlParams.get(name);
            if (param === null) { return null; }
            return param;
        }


        /**
         * Get query parameter from URI using its name
         * On null return Exception
         * @param name - parameter name
         * @return string|null - parameter value or null if not present
         */
        public static getQueryParamRequired(name: string) : string {
            const value = this.getQueryParam(name);
            if (value === null) { throw new Error('Impossible to find parameter: ' + name); }
            return value;
        }

        /**
         * Get view type as ENUM value or null if not present
         * @return ViewTypeEnum|number - view type
         */
        public static getViewType() : ViewTypeEnum|null {

            const viewTypeRaw = this.getQueryParam('viewType');
            if (viewTypeRaw === null) { return null; }
            return parseInt(viewTypeRaw) as ViewTypeEnum;
        }

        /**
         * Set viewType to URI
         * @return ViewTypeEnum|number - view type
         */
        public static setViewType(viewType: ViewTypeEnum|string) : void {

            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            urlParams.set('viewType', viewType.toString());

            const urlWithoutParams = location.protocol + '//' + location.host + location.pathname;
            const urlWithParams = urlWithoutParams + '?' + urlParams.toString();

            window.history.pushState( {viewType: viewType}, 'title', urlWithParams);
        }

        /**
         * Create link url from the parameters
         * @param modulePresenter - presenter name with module
         * @param component - component name
         * @param method - used HTTP method
         * @param parameters - requests parameters
         */
        public static composeLink({modulePresenter, component, method, parameters}: IComposeLinkParams) {

            const componentString = component ? component + "-" : "";
            const methodString = method ? `do=${componentString}${method}` : "";

            // Get starting prefix url (remove duplicated parameters)
            let presenterString;
            if (modulePresenter) {
                presenterString = `${modulePresenter.module}.${modulePresenter.presenter}`;
            } else {
                const location = new URL(window.location.href.split("#")[0]);
                for (const parameter of parameters) { location.searchParams.delete(`${componentString}${parameter.name}`); }
                presenterString = decodeURI(location.href);
            }

            let parametersString = "";
            if (parameters) {

                for (let i = 0; i < parameters.length; i++) {
                    const parameter: IComposeLinkParamsParameter = parameters[i];
                    if (!Array.isArray(parameter.value)) { continue; }
                    parameters.splice(i, 1);
                    for (let j = 0; j < parameter.value.length; j++) {
                        const parameterItem: string = parameter.value[j];
                        parameters.push({name: `${parameter.name}[${j}]`, value: parameterItem});
                    }
                }

                let counter = 0;
                parameters
                    .filter((element: { name: string, value: any }) => { return element.value !== null; })
                    .forEach((element: { name: string, value: any }) => {
                        const stringValue = typeof element.value === "boolean"
                            ? (element.value ? 1 : 0)
                            : element.value.toString();
                        parametersString += counter > 0 ? "&" : "";
                        parametersString += `${componentString}${element.name}=${stringValue}`;
                        ++counter;
                    });
            }

            let output = `${presenterString}`;
            output += parametersString.length > 0 ? `${output.includes('?') ? '&' : '?'}${parametersString}` : '';
            output += methodString.length > 0 ? `${output.includes('?') ? '&' : '?'}${methodString}` : '';
            return encodeURI(output);
        }
    }
}